import { create } from 'zustand';

// Simple mutual-exclusion slot so independent corner nudges (install
// banner, push-notification nudge, etc.) never stack on top of each other.
// Whoever claims the slot first gets to show; the loser just sits out for
// this app load - these are soft nudges, not critical UI, so no retry queue.
export const useNudgeStore = create((set, get) => ({
  activeNudge: null,
  claim: (id) => {
    if (get().activeNudge !== null && get().activeNudge !== id) return false;
    set({ activeNudge: id });
    return true;
  },
  release: (id) => {
    if (get().activeNudge === id) set({ activeNudge: null });
  },
}));
